import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type Theme = "light" | "dark";

interface ThemeState {
  theme: Theme;
  isHydrated: boolean;
}

interface ThemeActions {
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
  setHydrated: () => void;
}

type ThemeStore = ThemeState & ThemeActions;

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      // State
      theme: "light",
      isHydrated: false,

      // Actions
      toggleTheme: () =>
        set((state) => ({
          theme: state.theme === "light" ? "dark" : "light",
        })),

      setTheme: (theme) => set({ theme }),

      setHydrated: () => set({ isHydrated: true }),
    }),
    {
      name: "theme",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ theme: state.theme }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated();
      },
    }
  )
);

// Selector hooks for optimized re-renders
export const useTheme = () => useThemeStore((state) => state.theme);
export const useIsThemeHydrated = () => useThemeStore((state) => state.isHydrated);
export const useToggleTheme = () => useThemeStore((state) => state.toggleTheme);
